<template>
  <div class="section-header">
    <header>
      <div class="back-btn-container">
        <router-link
          v-if="$router.currentRoute.name === 'visualization'"
          to="/disease-progression"
          class="btn back"
          ><img
            class="arrow"
            src="@/assets/img/arrow-up-icon.svg"
          />Back</router-link
        >
        <router-link
          v-if="$router.currentRoute.name === 'disease-progression'"
          to="/"
          class="btn back"
          ><img class="arrow" src="@/assets/img/arrow-up-icon.svg" />Back to
          start</router-link
        >
      </div>
      <h1>MS Disease Progression Visualizer</h1>
      <div class="icon-container">
        <router-link
          @click.native="
            $gtag.event('click', {
              event_category: 'launch_tutorial',
              event_label: 'tutorial',
            })
          "
          to="/tutorial"
          class="icon tutorial"
        >
          <img class="arrow" src="@/assets/img/icon-tutorial.svg" />
        </router-link>
        <div class="audio-section">
          <button @click="toggleAudio($store.state.year)" class="audio">
            <img
              v-if="!$store.state.audioOn"
              class="arrow"
              src="@/assets/img/icon-audio.svg"
            />
            <img
              v-if="$store.state.audioOn"
              class="arrow"
              src="@/assets/img/icon-audio-play.svg"
            />
          </button>
          <div
            v-show="this.$store.state.audioInstructions === true"
            class="audio-instructions fade-ani"
          >
            Turn audio on/off
          </div>
        </div>
      </div>
    </header>

    <audio
      v-for="(audio, index) in 21"
      :key="audio.index"
      :id="`audio${index}`"
      ref="audio"
    >
      <source
        :src="require(`@/assets/audio/Year_${index}.mp3`)"
        type="audio/mp3"
      />
    </audio>
  </div>
</template>

<script>
export default {
  name: "InvTabs",
  props: {},
  computed: {},
  watch: {
    "$store.state.year": function (newyear, oldyear) {
      if (this.$store.state.audioOn) {
        // let currentAudio = document.getElementById("audio" + newyear);
        this.$store.toggleAudio(false);
        if (newyear !== oldyear) {
          this.$pauseSound();
          this.toggleAudio(newyear);
        }
      }
    },
  },
  mounted() {
    // Display audio instructions only once
    let self = this;
    if (self.$store.state.audioInstructions === true) {
      setTimeout(function () {
        self.$store.state.audioInstructions = false;
      }, 5000);
    }
  },
  methods: {
    toggleAudio: function (year) {
      if (this.$store.state.audioOn === false) {
        this.$playSound(
          require(`@/assets/audio/Year_${year}.mp3`),
          this.$store.toggleAudio(true)
        );

        // analytics
        if (year > 10) {
          this.$gtag.event("click", {
            event_category: "play_audio",
            event_label: `spms: ${year}`,
          });
        } else if (year > 5 && year < 11) {
          this.$gtag.event("click", {
            event_category: "play_audio",
            event_label: `late rrms: ${year}`,
          });
        } else if (year > 0 && year < 6) {
          this.$gtag.event("click", {
            event_category: "play_audio",
            event_label: `early rrms: ${year}`,
          });
        } else {
          this.$gtag.event("click", {
            event_category: "play_audio",
            event_label: "healthy",
          });
        }
      } else {
        this.$pauseSound();
        this.$store.toggleAudio(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  width: 100%;
  margin-bottom: rem(15px);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

h1 {
  font-size: rem(18px);
  margin: 0 auto;
  @include breakpoint(xs) {
    font-size: rem(14px);
    text-align: center;
  }
}

.back-btn-container {
  width: 150px;
  @include breakpoint(xs) {
    width: 100px;
  }
}

.btn.back {
  @include breakpoint(xs) {
    display: flex;
    align-items: center;
    font-size: rem(12px);
    img {
      width: 15px;
      margin-right: 10px;
    }
  }
  &:focus {
    outline: 4px solid#FFD086;
  }
}

.icon-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  @include breakpoint(xs) {
    width: 100px;
  }
  .icon {
    background: none;
    border: none;
    width: 25px;
    img {
      width: 100%;
    }
  }
  .tutorial {
    margin-right: 10px;
    @include breakpoint(xs) {
      margin-right: 10px;
      margin-left: 10px;
      width: 20px;
    }
  }

  .audio-section {
    position: relative;

    .audio {
      width: 32px;
      height: auto;
      background: none;
      border: none;

      @include breakpoint(xs) {
        padding: 0;
        width: 18px;
      }
      img {
        width: 100%;
        height: auto;
      }
    }

    .audio-instructions {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -40px;
      padding: 5px;
      margin: 5px 0;
      width: 100px;
      border: 2px solid #8ebefd;
      border-radius: 5px;
      font-size: rem(10px);
      font-weight: $font-weight-bold;
      text-align: center;
      cursor: default;
      opacity: 0;

      &:before {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid #8ebefd;
      }

      @include breakpoint(xs) {
        width: 50px;
        bottom: -60px;
      }
    }

    .fade-ani {
      animation-name: fade-in-out;
      animation-duration: 4s;
    }
  }
}

@keyframes fade-in-out {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
